import { Button } from "@mui/material";
import styled from "styled-components";
import { ButtonProps } from "./button.types";
import { palette, shape, typography } from "@src/core/styles";

export const StyledButton = styled(Button)<ButtonProps>`
  && {
    background-color: ${({ variant }) => {
      switch (variant) {
        case "label":
          return `${palette.colors.secondary_container}`;
        case "text":
          return "transparent";
        case "outlined":
          return "transparent";
        case "filled":
          return `${palette.colors.green_base}`;
        default:
          return `${palette.colors.green90}`;
      }
    }};
    border: ${({ variant }) => {
      return variant === "outlined" ? `${palette.border.outline}` : "none";
    }};
    color: ${({ variant }) => {
      switch (variant) {
        case "text":
          return `${palette.colors.green_base}`;
        case "outlined":
          return `${palette.colors.green_base}`;
        case "filled":
          return `${palette.colors.white_main}`;
        default:
          return `${palette.colors.green10}`;
      }
    }};
    text-transform: none;
    padding: ${({ variant }) => {
      switch (variant) {
        case "label":
          return `10px 16px`;
        case "outlined":
          return `10px 16px`;
        case "filled":
          return `10px 24px`;
        case "text":
          return `10px 12px`;
        default:
          return `16px`;
      }
    }};
    border-radius: ${({ borderradius }) => {
      switch (borderradius) {
        case "S":
          return `${shape.rounding.S}`;
        case "M":
          return `${shape.rounding.M}`;
        case "L":
          return `${shape.rounding.L}`;
        case "XL":
          return `${shape.rounding.XL}`;
        case "XXL":
          return `${shape.rounding.XXL}`;
        case "XXXL":
          return `${shape.rounding.XXXL}`;
      }
    }};
    ${typography.label_large};
    box-shadow: none;
  }
  & svg {
    path {
      fill: ${({ disabled }) =>
        disabled ? "rgba(0, 0, 0, 0.26)" : `${palette.colors.green_base}`};
    }
  }
  &&:hover {
    background-color: ${({ variant }) => {
      switch (variant) {
        case "text": {
          return "rgba(27, 109, 36, 0.08)";
        }
        case "outlined": {
          return "rgba(27, 109, 36, 0.08)";
        }
        case "filled": {
          return `rgba(45,121,54,255)`;
        }
        case "label": {
          return `${palette.colors.secondary_container}`;
        }
        default:
          return `${palette.colors.button_hover}`;
      }
    }};
    box-shadow: ${({ variant }) => {
      switch (variant) {
        case "label": {
          return "0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)";
        }
        case "contained": {
          return "0px 2px 3px 0px rgba(0, 0, 0, 0.30), 0px 6px 10px 4px rgba(0, 0, 0, 0.15)";
        }
        case "filled": {
          return "0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)";
        }
        default:
          return "none";
      }
    }};
    border: ${({ variant }) => {
      switch (variant) {
        case "outlined": {
          return `${palette.border.outline}`;
        }
        default:
          return "none";
      }
    }};
  }
`;

export const ButtonInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;
